/**
 * Created by Ivan on 17.05.2026
 */

const SeasonPassQuestPack = function (logic) {
    cleverapps.EventEmitter.call(this);

    this.logic = logic;
    this.mission = logic.mission;

    this.quests = [];
    this.removed = [];
    this.needShowNewTasks = false;
};

SeasonPassQuestPack.prototype = Object.create(cleverapps.EventEmitter.prototype);
SeasonPassQuestPack.prototype.constructor = SeasonPassQuestPack;

SeasonPassQuestPack.prototype.getConfig = function () {
    return bundles[`season_pass_${this.logic.period}_config`].jsons[`season_pass_${this.logic.period}_quests_json`].getJson();
};

SeasonPassQuestPack.prototype.calcCurrentDay = function () {
    const now = new Date();
    return Math.round(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) / cleverapps.parseInterval("1 day"));
};

SeasonPassQuestPack.prototype.getTimeLeft = function () {
    const now = new Date();

    const nextDay = new Date(now);
    nextDay.setDate(now.getDate() + 1);
    nextDay.setHours(0, 0, 0, 0);

    return nextDay - now;
};

SeasonPassQuestPack.prototype.load = function (data) {
    data = data || {};

    const isNewDay = data.refreshDay !== undefined && data.refreshDay !== this.calcCurrentDay();
    this.refreshDay = this.calcCurrentDay();

    if (isNewDay) {
        this.needShowNewTasks = true;
    }

    this.buildQuests(isNewDay ? {} : data);
};

SeasonPassQuestPack.prototype.buildQuests = function (data) {
    this.removed = Array.isArray(data.removed) ? data.removed.slice() : [];

    const saved = {};
    if (Array.isArray(data.quests)) {
        data.quests.forEach((quest) => {
            if (quest && quest.id) {
                saved[quest.id] = quest;
            }
        });
    }

    const config = this.getConfig();

    const groups = [];
    config.forEach((template) => {
        if (template.group && groups.indexOf(template.group) === -1) {
            groups.push(template.group);
        }
    });
    const activeGroup = groups.length ? groups[this.calcCurrentDay() % groups.length] : undefined;

    this.quests = [];
    config.forEach((template) => {
        if (template.group && template.group !== activeGroup) {
            return;
        }

        if (this.removed.indexOf(template.id) !== -1) {
            return;
        }

        const quest = new SeasonPassQuest(template);
        quest.resolveGoal(this.logic.stage);

        const state = saved[template.id];
        if (state) {
            quest.progress = parseInt(state.progress) || 0;
            quest.completed = !!state.completed;
        }

        this.quests.push(quest);
    });
};

SeasonPassQuestPack.prototype.resetDaily = function () {
    this.refreshDay = this.calcCurrentDay();
    this.buildQuests({});
    this.needShowNewTasks = true;

    this.mission.update();
    this.trigger("questsProgressed");
};

SeasonPassQuestPack.prototype.scheduleRefresh = function () {
    clearTimeout(this.refreshTimeout);
    this.refreshTimeout = new cleverapps.LongTimeout(this.onRefresh.bind(this), this.getTimeLeft());
};

SeasonPassQuestPack.prototype.onRefresh = function () {
    this.resetDaily();
    this.scheduleRefresh();
};

SeasonPassQuestPack.prototype.save = function () {
    return {
        refreshDay: this.refreshDay,
        removed: this.removed.slice(),
        quests: this.quests.map((quest) => quest.serialize())
    };
};

SeasonPassQuestPack.prototype.getActiveQuests = function () {
    return this.quests;
};

SeasonPassQuestPack.prototype.getNewTasks = function () {
    return this.getActiveQuests().filter((quest) => !quest.repeatable);
};

SeasonPassQuestPack.prototype.isBonusUnlocked = function () {
    return !this.quests.some((quest) => !quest.repeatable && !quest.bonus && !quest.completed);
};

SeasonPassQuestPack.prototype.isQuestLocked = function (quest) {
    return quest.bonus && !this.isBonusUnlocked();
};

SeasonPassQuestPack.prototype.hasQuest = function (type) {
    return this.logic.canEarnPoints() && this.quests.some((quest) => quest.type === type && !quest.isFinished() && !this.isQuestLocked(quest));
};

SeasonPassQuestPack.prototype.applyProgress = function (type, amount) {
    if (!this.logic.canEarnPoints() || this.quests.length === 0) {
        return;
    }

    this.quests.forEach((quest) => {
        if (quest.type !== type || quest.completed || quest.isFinished() || this.isQuestLocked(quest)) {
            return;
        }
        if (quest.addProgress(amount)) {
            this.logic.logEvent(cleverapps.EVENTS.SEASON_PASS.QUEST + quest.type);
            if (quest.bonus) {
                this.logic.logEvent(cleverapps.EVENTS.SEASON_PASS.QUEST_BONUS);
            }
            this.logic.awardQuestPoints(quest);
            this.trigger("questCompleted", quest);
        }
    });

    this.mission.update();
    this.trigger("questsProgressed");
};

SeasonPassQuestPack.prototype.hasCompletedPending = function () {
    return this.quests.some((quest) => quest.completed);
};

SeasonPassQuestPack.prototype.getCompletedPending = function () {
    return this.quests.filter((quest) => quest.completed);
};

SeasonPassQuestPack.prototype.acknowledgeCompleted = function () {
    let changed = false;

    this.quests.slice().forEach((quest) => {
        if (!quest.completed) {
            return;
        }
        changed = true;

        if (quest.repeatable) {
            quest.reset(this.logic.stage);
        } else {
            this.removed.push(quest.id);
            const idx = this.quests.indexOf(quest);
            if (idx !== -1) {
                this.quests.splice(idx, 1);
            }
        }
    });

    if (changed) {
        this.mission.update();
        this.trigger("questsProgressed");
    }
};
